import {Injectable} from '@angular/core';
import {BaseModelService} from '../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class LocalFamiliesModelService extends BaseModelService {

  tableName = 'yu_v3_local_families';

}
